module.exports = __webpack_public_path__ + "media/images/faces/female/16-bbc9579299dc4f774ecbd54256dcf88c.jpg";